import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import HelpBlock from "components/bootstrap/HelpBlock";
import MarkdownEditorModal from "components/common/MarkdownEditor/EditorModal";
const AddNotesModal = ({ closeModal, onConfirm, show = false }) => {
  const { t } = useTranslation("enterprise_security_events");
  const [notes, setNotes] = useState("");
  const helpBlock = /* @__PURE__ */ React.createElement(HelpBlock, null, t("add_notes_modal.help_text"));
  return show ? /* @__PURE__ */ React.createElement(
    MarkdownEditorModal,
    {
      value: notes,
      show,
      onChange: setNotes,
      onClose: closeModal,
      onDone: onConfirm,
      helpBlock
    }
  ) : null;
};
export default AddNotesModal;
